import { render, staticRenderFns } from "./SSOLogin.vue?vue&type=template&id=248e5790&scoped=true&"
import script from "./SSOLogin.vue?vue&type=script&lang=js&"
export * from "./SSOLogin.vue?vue&type=script&lang=js&"
import style0 from "./SSOLogin.vue?vue&type=style&index=0&id=248e5790&lang=scss&scoped=true&"
import style1 from "./SSOLogin.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248e5790",
  null
  
)

export default component.exports